import {
  ADMIN_CREATE_BRAND_REQUEST,
  ADMIN_CREATE_BRAND_SUCCESS,
  ADMIN_CREATE_BRAND_FAIL,
  ADMIN_LIST_BRAND_REQUEST,
  ADMIN_LIST_BRAND_SUCCESS,
  ADMIN_LIST_BRAND_FAIL,
  ADMIN_ALL_BRAND_REQUEST,
  ADMIN_ALL_BRAND_SUCCESS,
  ADMIN_ALL_BRAND_FAIL,
  ADMIN_VIEW_BRAND_REQUEST,
  ADMIN_VIEW_BRAND_SUCCESS,
  ADMIN_VIEW_BRAND_FAIL,
  ADMIN_UPDATE_BRAND_REQUEST,
  ADMIN_UPDATE_BRAND_SUCCESS,
  ADMIN_UPDATE_BRAND_FAIL,
  ADMIN_REMOVE_BRAND_REQUEST,
  ADMIN_REMOVE_BRAND_SUCCESS,
  ADMIN_REMOVE_BRAND_FAIL,
  ADMIN_REFRESH_BRAND_FAIL,
  ADMIN_REFRESH_BRAND_REQUEST,
  ADMIN_REFRESH_BRAND_SUCCESS,
  BRAND_DELETE_FAIL,
  BRAND_DELETE_REQUEST,
  BRAND_DELETE_SUCCESS,
} from "./brandTypes";

export const brandReducer = (state = { brands: [] }, action) => {
  switch (action.type) {
    // CREATE

    case ADMIN_CREATE_BRAND_REQUEST:
      return { ...state, loading: true };
    case ADMIN_CREATE_BRAND_SUCCESS:
      return { ...state, loading: false, brandAddedSuccess: action.payload.message, success: true };
    case ADMIN_CREATE_BRAND_FAIL:
      return { ...state, loading: false, error: action.payload };
    case "ADMIN_CREATE_BRAND_RESET":
      return { ...state, loading: false, brandAddedSuccess: {}, success: false };

    // LIST
    case ADMIN_LIST_BRAND_REQUEST:
      return { ...state, loading: true };
    case ADMIN_LIST_BRAND_SUCCESS:
      return {
        ...state,
        loading: false,
        brandslist: action.payload.brands,
        totalBrandCount: action.payload.totalBrandCount,
      };
    case ADMIN_LIST_BRAND_FAIL:
      return { ...state, loading: false, error: action.payload };

    // LIST
    case ADMIN_ALL_BRAND_REQUEST:
      return { ...state, loading: true };
    case ADMIN_ALL_BRAND_SUCCESS:
      return {
        ...state,
        loading: false,
        allBrands: action.payload,
      };
    case ADMIN_ALL_BRAND_FAIL:
      return { ...state, loading: false, error: action.payload };

    //  VIEW
    case ADMIN_VIEW_BRAND_REQUEST:
      return { ...state, loading: true };
    case ADMIN_VIEW_BRAND_SUCCESS:
      return { ...state, loading: false, singleBrand: action.payload };
    case ADMIN_VIEW_BRAND_FAIL:
      return { ...state, loading: false, error: action.payload };

    // UPDATE
    case ADMIN_UPDATE_BRAND_REQUEST:
      return { ...state, loading: true };
    case ADMIN_UPDATE_BRAND_SUCCESS:
      return { ...state, loading: false, updatedBrand: action.payload._id };
    case ADMIN_UPDATE_BRAND_FAIL:
      return { ...state, loading: false, error: action.payload };

    //BRAND DELETE FROM ALL MERCHANTS
    case BRAND_DELETE_REQUEST:
      return { ...state, loading: true };
    case BRAND_DELETE_SUCCESS:
      return { ...state, loading: false, deletedBrand: action.payload };
    case BRAND_DELETE_FAIL:
      return { ...state, loading: false, error: action.payload };

    // DELETE
    case ADMIN_REMOVE_BRAND_REQUEST:
      return { ...state, loading: true };
    case ADMIN_REMOVE_BRAND_SUCCESS:
      return { ...state, merchant: action.payload, loading: false };

    default:
      return state;
  }
};
